import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33398 6.43767V3H14.6673V6.43767C13.9612 6.68933 13.4552 7.36843 13.4552 8.16667C13.4552 8.9649 13.9612 9.644 14.6673 9.89567V13.3333H1.33398V9.89567C2.04016 9.644 2.5461 8.9649 2.5461 8.16667C2.5461 7.36843 2.04016 6.68933 1.33398 6.43767Z"
      fill="#7F8B91"
      stroke="#7F8B91"
      strokeWidth={0.666667}
      strokeLinejoin="round"
    />
    <path
      d="M6.33398 5.3335L8.00065 7.00016L9.66732 5.3335"
      stroke="#DDD6D6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.3335H10"
      stroke="#DDD6D6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 9.38867H10"
      stroke="#DDD6D6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7.3335V11.3335"
      stroke="#DDD6D6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
